import {
  GraduationCap,
} from "lucide-react";
import type { TenantFeatureKey } from "./featureRouteRegistry.types";

export interface FeatureRoute {
  key: string;
  path: string;
  component: string;
  label: string;
  icon: React.ElementType;
  group: "core" | "niche" | "management";
}

/**
 * Maps a TenantFeature key → the sidebar route(s) it unlocks.
 * To gate a new route behind a tenant feature:
 *   1. Add the feature key to TENANT_FEATURE_KEYS on the server
 *   2. Add an entry here
 *   3. Register the component in ROUTE_COMPONENTS (registry.tsx)
 * No changes needed in useRouterData — it reads from this registry automatically.
 */
export const FEATURE_ROUTE_REGISTRY: Record<TenantFeatureKey, FeatureRoute[]> = {
  student_portal: [
    {
      key: "student-portal",
      path: "/student-portal",
      component: "StudentPortalPage",
      label: "Student Portal",
      icon: GraduationCap,
      group: "management",
    },
  ],
};
